<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
// Import the PharmacyProfileForm component
import PharmacyProfileForm from '@/components/Pharmacy/PharmacyProfileForm';

defineProps({
    pharmacy: {
        type: Object,
        default: () => ({
            // Default pharmacy object
            name: '',
            delivery_rate: 0,
            discount_amount: 0,
            contact_phone: '',
            contact_first_name: '',
            contact_last_name: '',
            contact_email: '',
            status_id: null,
        }),
    },
    mode: {
        type: String,
        default: 'Create',
    },
});

const emit = defineEmits(['close-modal']);

const pharmacyProfileFormRef = ref(null);

const save = async () => {
    if (pharmacyProfileFormRef.value) {
        await pharmacyProfileFormRef.value.save(); // Call the save method in PharmacyProfileForm
        emit('close-modal');
    }
};
</script>

<template>
<ModalWrapper>
    <template #header>{{ $t('label.mode_what', { 'mode' : mode, 'what' : 'pharmacy' }) }}</template>
    <template #subheader>{{ $t('label.create_or_edit', { 'what' : 'pharmacy' }) }}</template>

    <!-- Use PharmacyProfileForm -->
    <PharmacyProfileForm
        ref="pharmacyProfileFormRef"
        :pharmacy="pharmacy"
        :mode="mode"
        @saved="emit('close-modal')" />

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
